import styled from 'styled-components';

export const TagContainer = styled.div`
.tag_sections {
    position: relative;
    left: 10px;
    top: 56px;
}

.tag_sections .ant-card {
    background-color:#33363C !important;
    color: #ffffff !important;
    box-shadow: none;
}
.tag_sections .ant-card-head{
    color: #ffffff !important;
    border-bottom:  1px solid #6A727C !important;
}
.tag_sections .ant-card-body{
    padding: 10px;
    max-height: 80vh;
    overflow-y: auto;
}
.tag_sections .ant-collapse{
    border: 0px;
    border-radius: 0px ;
}
.tag_sections .ant-collapse-item{
    border: 0px;
    border-radius: 0px;
}
.tag_sections .ant-collapse-header{
    color: #ffffff !important;
    padding:5px 12px !important;
}
.tag_sections .ant-space{
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.tag_sections  .ant-collapse-content{
    background-color:#33363C !important;
    color: #ffffff !important;
    border-top: 0px;
    border-bottom: 1px solid #6A727C;
    border-radius: 0px !important;
}
.tag_sections .content {
    background-color:#5C5E63;
    padding: 8px;
    border-radius: 4px;
}
.tag_sections .ant-collapse-content-box{
    padding-top: 0px !important;
}

.tag_sections .ant-collapse{
    height: auto;
    overflow: auto;
    margin-bottom: 5px;
    max-height: 70vh;
    user-select: none;
}
.tag_sections .new_tag {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 10px;
}
.tag_sections  .btn_tag{
    background-color:  #36BDBE;
    color:#122C31;
    padding: 8px 16px;
    display: flex;
    align-items: center;
    border: 0px;
}
.tag_sections  .btn_tag:hover{
    color: #ffffff !important;
}
.tag_sections .create_tag{
    background-color:#5C5E63;
    color: #ffffff;
    border-radius: 8px;
    padding: 10px;
}
.tag_sections h2.title_tag {
    text-align: center;
}
.tag_sections .form_section {
    margin-top: 15px;
}
.tag_sections  .sub_title{
    display: flex;
    justify-content: space-between;
    align-items: center;
    color:#CDCED0;
}
.tag_sections  .sub_title p{
    margin: 0px;
    color: #FFFFFF;
}
.tag_sections  .ant-row{
    display: block;
}
.tag_sections  .ant-form-item-label{
    text-align: left;
}
.tag_sections .ant-form-item{
    margin-bottom: 10px;
}
.tag_sections .ant-form-item-label label{
    color: #ffffff;
}
.tag_sections .ant-input{
    background-color: #424447;
    color: #ffffff;
    padding:5px;
    border: 1px solid #7F8082;  
}
.tag_sections .ant-input:hover{
    border: 1px solid #7F8082;  
}
.tag_sections .accordion_title{
    display: flex;
    align-items: center;
    margin:3px;
    gap: 3px;
}
.tag_sections .ant-form-item-control-input-content .ant-space{
    justify-content: center;
}
.tag_sections .footer_btn {
    margin-top: 20px;
    justify-content: center;
}
.tag_sections .save_btn{
    background-color: #36BDBE;
    color:#122C31;
    padding: 8px 16px;
    display: flex;
    align-items: center;
    border: 0px;
}
.tag_sections .cancel_btn{
    background-color:  #36BDBE;
    color:#122C31;
    padding: 8px 16px;
    display: flex;
    align-items: center;
    border: 0px;
}

.tag_sections  .save_btn:hover , .tag_sections  .cancel_btn:hover{
    color: #ffffff !important;
}
.tag_sections .anticon-eye:hover svg{
    fill: #36BDBE;
}

.tag_sections .anticon-delete:hover svg{
    fill: #36BDBE;
}
.tag_sections .anticon-edit:hover svg{
    fill: #36BDBE; 
}
.ant-space-item .accordion_title span:hover{
    color: #36BDBE;
}
.tag_sections .accordian_number {
    color:#999A9D;
}
.tag_sections .save_btn:disabled{
    background-color:#537579;
}
.tag_sections .save_btn:disabled:hover {
    background-color:#537579;
    color:#122C31 !important; 
}
.tag_sections .accordion_icon {
    display: flex;
    align-items: center;
    gap: 5px;
}
.tag_sections .sub_title_message{
    display: flex;
    justify-content: center;
    align-items: center;
    color: #36BDBE;
    background-color: #6C6E72;
    padding: 5px;
    margin-top: 5px;
    border-radius: 2px;
    font-size: 14px;
    font-weight:600;
    gap: 5px;
}
.tag_sections .map_point {
    margin-top: 10px;
    background-color: #505255;
    padding: 5px;
    color: #CACACC;
    border-radius: 4px;
    border: 1px solid #606266;
}
.tag_sections .ant-input-affix-wrapper {
    background-color: #424447;
    border: 1px solid #7F8082;
    color: #ffffff;
    padding-left:0px;
}
  .tag_sections .input_with_icon {
    margin-bottom: 10px;
}
.tag_sections .textarea_section{
    border: 1px solid #7F8082;
}
.tag_sections .custom-up-icon{
    font-size:27px;
    vertical-align: middle;
}
.tag_sections .custom-down-icon{
    font-size:27px;
    vertical-align: middle;
}
.tag_sections .accordion_tag {
    max-width: 150px; 
    white-space: nowrap; 
    overflow: hidden; 
    text-overflow: ellipsis; 
    display:inline-block;
  }
  .save-cancel-icons{
    display:flex;
    gap:5px;
    align-items:center;
    margin-top: 10px;
  }
  .save-cancel-icons svg:hover{
    color: #36BDBE;
  }
  .save-cancel-icons .anticon-check-circle svg , .save-cancel-icons .anticon-check-circle path {
    fill: green;
  }
  .save-cancel-icons .anticon-close-circle svg , .save-cancel-icons .anticon-close-circle path {
    fill: red;
  }
  .accordion_tag .ant-input{
    background-color: #424447;
    color: #ffffff;
    padding:5px;
    border: 0px; 
  }
  .content .ant-input{
    background-color: transparent;
    color: #ffffff;
    padding:5px;
    border: 0px; 
  }
  .accordion_tag .ant-input:hover , .content .ant-input:hover {
    border: 0px;
}
.tag_sections .ant-input:focus{
    box-shadow: none;
}
`;